import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { request } from "@/js/http/http_request";
import regionComponent from "@/components/region/RegionComponent.vue";
export default {
  name: "adminRegionDetails",
  props: ["loggedUserData"],
  data: function data() {
    return {
      region: {
        regionSubs: []
      }
    };
  },
  created: function created() {
    this.idRegion = this.$route.query.idRegion;
    if (!this.idRegion) {
      this.$router.push({
        name: "adminProductList"
      });
    } else {
      var _this$$route$params$s;
      if ((_this$$route$params$s = this.$route.params.searchCriterias) !== null && _this$$route$params$s !== void 0 && _this$$route$params$s.idRegionOrigin) {
        this.idRegion = this.$route.params.searchCriterias.idRegionOrigin;
      }
      this.$EventBus.$emit("loading", true);
      var _this = this;
      request("/v1/regions/" + _this.idRegion, "get", null, true, "api").then(function (response) {
        _this.region = _objectSpread({}, response.data);
        _this.$EventBus.$emit("loading", false);
      });
    }
  },
  components: {
    region: regionComponent
  }
};